<template lang="html">
       <PassCode :forcePass="true" class="forceArea" @go-frash="goFrash"></PassCode>
</template>

<script>
import PassCode from '@/views/components/userSet/passReset';
import { userSSet } from '@/api/login';
export default {
    components:{
        PassCode
    },
    data(){
        return{

        }
    },
    methods:{
        goFrash:function(){
             userSSet().then(() => {});
             this.$router.push("/");
        }
    }
}
</script>

<style lang="css">

.forceArea table{
    margin: 0 auto;
    margin-top: 120px;
}

.forceArea table .textName{
    width: 60px;
    padding-top: 0px;
}

.forceArea .el-form-item__error{
    width: 120px;
    position: absolute !important;
    left: 240px;
    top: 12px;
}


/* .forceArea table */

</style>



// WEBPACK FOOTER //
// passSet.vue?6d9144c8